<template>
  <el-text-field
    :class="compClass +
      ((getForAccessibility) ? ' for-accessibility-app ' : '')"
    v-model="elValue"
    :label="label"
    :tooltip="tooltip"
    :placeholder="placeholder"
    v-mask="dateMask"
    :disabled="disabled"
    :readonly="readonly"
    :required="required"
    date
    :future-dates="futureDates"
    :past-dates="pastDates"
    :past-date="pastDate"
    :future-term-dates="futureTermDates"
    :today="today"
    :autofocus="autofocus"
    :hide-details="hideDetails"
    :afterDate="afterDate"
    :validateKey="validateKey"
    @change="change"
    :validateOnInput="validateOnInput"
  >
    <v-menu
      v-if="!disabled && !readonly"
      style="z-index: 200;"
      slot="append"
      :class="classP"
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
      :disabled="disabled"
      :readonly="readonly"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on" :disabled="disabled || readonly">
          mdi-calendar-month-outline
        </v-icon>
      </template>
      <v-date-picker
        :class="((getForAccessibility) ? ' for-accessibility-app ' : '')"
        :readonly="readonly"
        :disabled="disabled"
        :allowed-dates="allowedDates"
        first-day-of-week="1"
        :locale="getlocale"
        v-model="picker"
        @input="saveDate()"
        @change="change"
      ></v-date-picker>
    </v-menu>
  </el-text-field>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ElDatePicker',
  props: {
    classP: String,
    label: String,
    placeholder: { type: String, default: 'MMMM-MM-DD' },
    tooltip: String,
    required: Boolean,
    need: Boolean,
    value: String,
    disabled: Boolean,
    readonly: Boolean,
    pastDates: Boolean,
    pastDate: String,
    futureTermDates: String,
    futureDates: Boolean,
    autofocus: { type: Boolean, default: false },
    afterDate: String,
    afterDates: String,
    beforeDates: String,
    validateKey: String,
    hideDetails: [Boolean, String],
    validateOnInput: Boolean,
  },
  data() {
    return {
      menu: false,
      picker: null,
    }
  },
  inject: {
    $validator: '$validator',
  },
  watch:{
     menu() {
       this.picker = this.elValue
       if(!this.elValue){
         this.picker = this.today
       }
    },
  },
  computed: {
    ...mapGetters(['getForAccessibility']),
    elValue: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
        this.checkDateFormat(elValue)
      },
    },
    getlocale() {
      return this.$i18n.locale === 'lt' ? 'lt' : 'en'
    },
    dateMask() {
      return [/[1-2]/, /\d/, /\d/, /\d/, '-', /[0-1]/, /\d/, '-', /[0-3]/, /\d/]
    },
    today() {
      let today = new Date()
      return `${today.getFullYear()}-${this.paddingZero(
        today.getMonth() + 1
      )}-${this.paddingZero(today.getDate())}`
    },
    requiredClass() {
      return (this.required || this.need) && !this.readonly
        ? 'required-input'
        : ''
    },
    compClass() {
      return `${this.classP} ${this.requiredClass} labelPatch`
    },
  },
  created() {
    //
  },
  methods: {
    change() {
      this.$emit('change')
    },
    saveDate() {
      this.menu = false
      this.elValue = this.picker
    },
    checkDateFormat(elValue) {
      var dateformat = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/
      if (elValue.match(dateformat)) {
        this.picker = elValue
        let name = this.validateKey || this.label
        const field = this.$validator.fields.find({ name: name })
        field.reset()
        this.$validator.errors.remove(field.name, field.scope)
      } else {
        this.picker = null
      }
    },
    paddingZero(str) {
      return String(str).padStart(2, '0')
    },
    allowedDates(val) {
      if (this.beforeDates && this.futureDates) {
        return val >= this.today && val <= this.beforeDates
      }
      if (this.pastDates) {
        return val <= this.today
      }
      if (this.futureDates) {
        return val >= this.today
      }
      if( this.afterDates) {
         return val >= this.afterDates
      }
      if( this.beforeDates) {
         return val <= this.beforeDates
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/elements.scss';
</style>
